import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import {forgetPassword, DO_FORGET_PWD_FAIL, forwardForgotPwd } from '../../actions/login/index';
import Loading from '../common/Loading';
import { commonRenderInput } from '../../components/common/access-form';
import {verifyAccount, verifyForm} from '../../components/common/access-form-validation';

import '../../resources/css/login/ForgotPwdForm.scss';

class ForgotPwdForm extends Component {

  formSubmit = (values) => {
    const { forgetPassword, forwardForgotPwd } = this.props;
    forgetPassword(values.email);
    forwardForgotPwd(values);
  }

  render() {
      const { handleSubmit, verifyFormPass, forgotPwdLoading, status, errMsg } = this.props;
      let alertMsg = (
        <div className='area-alert-msg'></div>
      );

      if (status === DO_FORGET_PWD_FAIL) {
        alertMsg = (
          <div className='area-alert-msg'><label>{ errMsg }</label></div>
        );
      }

      let btnSubmit = (
        <div className='area-btn-forgot-pwd'>
            <Button id="forgot-password-form-submit" type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                Submit
            </Button>
        </div>
      );

      return (
        <div className='area-forgot-pwd-form form-custom'>
            <div className='area-tip'>Please enter your email address associated with your account.</div>
            <form id="forgot-password-form" className='change-pwd-form' onSubmit={handleSubmit(this.formSubmit)}>
            {/*<div className='area-form-group'>*/}
            {/*    <div className='area-form-label'>*/}
            {/*        <label className='need-star-label'></label><label>Account</label>*/}
            {/*    </div>*/}
            {/*    <div className='area-form-field'>*/}
            {/*        <Field name="account" type="text" component={commonRenderInput} placeholder="Please input your account" />*/}
            {/*    </div>*/}
            {/*</div>*/}
            <div className='area-form-group'>
                <div className='area-form-label'>
                    <label className='need-star-label'></label><label>Email</label>
                </div>
                <div className='area-form-field'>
                    <Field
                        id="forgot-password-form-email"
                        name="email"
                        type="text"
                        component={commonRenderInput}
                        placeholder="Please input your email address"
                        validate={[verifyAccount]}
                    />
                </div>
            </div>
            { alertMsg }
            <div className='area-submit-btn'>
              { btnSubmit }
            </div>              
          </form>
          <Loading loading={forgotPwdLoading} center={true}></Loading>
        </div>
      );
  }
}

const mapStateToProps = (state, ownProps) => {
  const verifyFormPass = verifyForm(state.form['ForgotPwdForm']);

  return {
    status: state.loginReducers.status,
    forgotPwdLoading: state.loginReducers.forgotPwdLoading,
    errMsg: state.loginReducers.errMsg,    
    verifyFormPass : verifyFormPass,
    formValues: getFormValues('ForgotPwdForm')(state)
  }
};

ForgotPwdForm = reduxForm({
  form: 'ForgotPwdForm',  // a unique identifier for this form
  // touchOnBlur: true,
  // touchOnChange: true
})(ForgotPwdForm)

export default withRouter(connect(
  mapStateToProps,
  { forgetPassword, forwardForgotPwd }
)(ForgotPwdForm));